<template lang="html">
    <div>
        <!-- <div style="overflow-x:auto"> -->
            <table class="table budgets has-mobile-cards">
                <thead>
                    <tr>
                        <th>Budget</th>
                        <th>Amount</th>
                        <th>Range</th>
                        <th>Campaigns</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="budget in client.budget_groups">
                        <td data-label="Name">
                            <a @click="showDetails(budget)" v-text="budget.name"></a>
                        </td>
                        <td data-label="Budget">{{ budget.budget | currency }}</td>
                        <td data-label="Range">{{ getRange(budget.type,budget.start,budget.end) }}</td>
                        <td data-label="Campaigns">{{ campaignCount(budget) }}</td>
                        <td data-label="Remove" v-if="budget.name !== 'Monthly'"><button class="btn btn-danger-outline btn-sm" @click="showDeleteConfirmation(budget)">
                            <span class="fa fa-trash-o"></span>
                        </button></td>
                    </tr>
                </tbody>
            </table>
        <!-- </div> -->

          <div class="modal fade" id="modal-delete-budget-group" tabindex="-1" role="dialog">
              <div class="modal-dialog">
                  <div class="modal-content">
                      <div class="modal-header">
                          <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                          <h4 class="modal-title">
                              Delete Budget Group?
                          </h4>
                      </div>
                      <div class="modal-body">
                          Are you 100% sure that you would like to delete this budget group?
                      </div>
                      <!-- Modal Actions -->
                      <div class="modal-footer">
                          <button type="button" class="btn btn-danger" @click="deleteBudgetGroup">Yes</button>
                          <button type="button" class="btn btn-default" data-dismiss="modal">Nope</button>
                      </div>
                  </div>
              </div>
          </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

    data() {
        return {
            currentBudget: {},
            loading: false
        }
    },

    computed: {
        ...mapGetters('client', {
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },

    mounted() {
        this.currentBudget.start = `${moment().date(1).format('YYYY-MM-DD')}`;
        this.currentBudget.end = `${moment().add(1,'month').date(0).format('YYYY-MM-DD')}`;
    },

    methods: {
        showDetails(group) {
            history.pushState(null, null, `#/clients/${this.client.slug}/budget-groups/${group.id}`);
            this.$store.dispatch('client/showBudgetGroupDetails', {
                group: group
            });
        },

        showDeleteConfirmation(budget) {
            this.currentBudget = budget;
            $('#modal-delete-budget-group').modal('show');
        },

        deleteBudgetGroup() {
            let budgetGroup = this.currentBudget;
            this.$store.dispatch('client/deleteBudgetGroup', {
                    budgetGroup: budgetGroup
                }).then(response => {
                    Bus.$emit('show-success-alert', response.message);
                    this.reset();
                    $('#modal-delete-budget-group').modal('hide');
                })
                .catch(response => {
                    if (response.status === 403) {
                        Bus.$emit('show-error-alert', response.data.message);
                    }
                });
        },

        campaignCount(group) {
            return group.name === 'Monthly' ? 'All' : group.campaigns.length;
        },

        getRange(type, start, end) {
            return type === 'monthly' ? 'Monthly' : `${start} - ${end}`;
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    }
}
</script>

<style scoped>
a:hover {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/BudgetGroupList.vue